"use client";

import { useCurrentFrame, useVideoConfig, interpolate } from "remotion";

export default function IrisTransition() {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();

  const midPoint = fps * 1.25;
  const totalFrames = fps * 2.5;

  // First half: iris closes (75% → 0%)
  // Second half: iris opens (0% → 75%)
  const radius = frame <= midPoint
    ? interpolate(frame, [0, midPoint], [75, 0], {
        extrapolateRight: "clamp",
      })
    : interpolate(frame, [midPoint, totalFrames], [0, 75], {
        extrapolateLeft: "clamp",
        extrapolateRight: "clamp",
      });

  const showSceneA = frame <= midPoint;

  return (
    <div
      style={{
        position: "relative",
        width: "100%",
        height: "100%",
        backgroundColor: "#000000",
        overflow: "hidden",
      }}
    >
      {/* Scene underneath (B when closing, A already gone) */}
      {!showSceneA && (
        <div
          style={{
            position: "absolute",
            inset: 0,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            background: "linear-gradient(135deg, #3b1f5e, #111827)",
            clipPath: `circle(${radius}% at 50% 50%)`,
          }}
        >
          <div
            style={{
              width: "80px",
              height: "80px",
              borderRadius: "12px",
              background: "linear-gradient(135deg, #a855f7, #7209b7)",
              marginBottom: "1rem",
            }}
          />
          <h2
            style={{
              color: "white",
              fontSize: "2.5rem",
              fontWeight: "bold",
              margin: 0,
              fontFamily: "Inter, sans-serif",
            }}
          >
            Scene B
          </h2>
          <p style={{ color: "#c084fc", fontSize: "1.1rem", marginTop: "0.5rem" }}>
            Iris opening...
          </p>
        </div>
      )}

      {/* Scene A with iris closing */}
      {showSceneA && (
        <div
          style={{
            position: "absolute",
            inset: 0,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            background: "linear-gradient(135deg, #1e3a5f, #111827)",
            clipPath: `circle(${radius}% at 50% 50%)`,
          }}
        >
          <div
            style={{
              width: "80px",
              height: "80px",
              borderRadius: "50%",
              background: "linear-gradient(135deg, #3b82f6, #1d4ed8)",
              marginBottom: "1rem",
            }}
          />
          <h2
            style={{
              color: "white",
              fontSize: "2.5rem",
              fontWeight: "bold",
              margin: 0,
              fontFamily: "Inter, sans-serif",
            }}
          >
            Scene A
          </h2>
          <p style={{ color: "#93c5fd", fontSize: "1.1rem", marginTop: "0.5rem" }}>
            Iris closing...
          </p>
        </div>
      )}
    </div>
  );
}

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
